import { DialogProps } from '@mui/material';
import { TokenUsageMetadata } from 'api/model.ts';
import InfoDialog from './InfoDialog';
import TokenUsageDisplay from './TokenUsageDisplay';

type TokenUsageDialogProps = {
  open: boolean;
  onClose: () => void;
  tokenUsage?: TokenUsageMetadata;
  nodeTokenUsage?: TokenUsageMetadata;
} & DialogProps;

const TokenUsageDialog = ({ open, onClose, tokenUsage, nodeTokenUsage }: TokenUsageDialogProps) => {
  return (
    <InfoDialog open={open} buttonsSettings={{ confirmText: 'Close' }} onCancel={onClose} onConfirm={onClose}>
      <div className="flex flex-row gap-12">
        {nodeTokenUsage && <TokenUsageDisplay title="Node Token Usage" tokenUsage={nodeTokenUsage} />}
        {tokenUsage && <TokenUsageDisplay title="Accumulated Token Usage" tokenUsage={tokenUsage} />}
      </div>
    </InfoDialog>
  );
};

export default TokenUsageDialog;
